module.exports = __webpack_public_path__ + "img/forum_thumbnail.b9dabf6b.jpg";